module.exports = new __parcel__URL__("report-epic.c7c0b53c.svg").toString();